import { useUser } from "@clerk/clerk-react";
import { isAdmin } from "@/lib/admin";

export function useIsAdmin(): boolean {
  const { user } = useUser();
  return isAdmin(user?.primaryEmailAddress?.emailAddress);
}
